import { NextSeo, NextSeoProps } from "next-seo";

import { useRouter } from "next/router";

import React from "react";

import { AlternateLangUrl } from "../../../context/alternateLangContext/context";

type Props = {
    title?: string;
    description?: string;
    canonical?: string | null;
    alternateLinks?: AlternateLangUrl[];
    openGraph?: NextSeoProps["openGraph"];

    // eslint-disable-next-line react/require-default-props
    noindex?: boolean;
    titleTemplate?: string;
};

const origin =
    process.env.NODE_ENV === "development"
        ? `http://localhost:3333`
        : `https://carl-topham.com`;

const SEO = ({
    title,
    description,
    alternateLinks,
    openGraph,
    canonical,
    noindex = false,
    titleTemplate = "%s - Carl Topham"
}: Props) => {
    const { locale, asPath } = useRouter();

    // Add the x-default to the language alternates

    const XDefault =
        // find the default locale link
        alternateLinks?.find((link) => link.hrefLang === "en") ||
        // or the fr link
        alternateLinks?.find((link) => link.hrefLang === "fr");

    const updatedAlternateLinks = alternateLinks ? [...alternateLinks] : undefined;

    if (XDefault) {
        updatedAlternateLinks?.push({
            href: XDefault.href,
            hrefLang: "x-default"
        });
    }

    return (
        <NextSeo
            // Set the title
            title={title}
            titleTemplate={titleTemplate}
            defaultTitle="Carl Topham"
            // Description
            description={description}
            // Alternate links
            languageAlternates={updatedAlternateLinks}
            // build openGraph
            openGraph={{ ...openGraph, locale }}
            noindex={noindex}
            canonical={canonical || `${origin}${asPath}`}
        />
    );
};

SEO.defaultProps = {
    title: undefined,
    description: "JavaScript &amp; React Engineer.",
    alternateLinks: undefined,
    openGraph: undefined,
    titleTemplate: "%s - Carl Topham"
};

export default SEO;
